import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';

import * as Action from './actions';
import Influencer from './../../components/influencer';

import LoadingView from './../../components/loading';
import YoutubeFeed from './../../components/latest-youtube-videos';
import LatestTweets from './../../components/latest-tweets';
import InstagramFeed from './../../components/latest-instagram-posts';
import SocialShare from './../../components/social-share';
import Header from './../../components/header';
import Footer from './../../components/footer';

import { influencerService } from '../../services/influencer-service';

class Profile extends React.Component {

  static contextTypes = {
    router: PropTypes.object,
  }

  static propTypes = {
    routeParams: React.PropTypes.object.isRequired,
  }

  componentDidMount() {
    this.props.loadPage();
    const slug = this.props.routeParams ? this.props.routeParams.slug : null;
    if (slug) {
      this.getInfluencer(slug);
    }
  }

  getInstagramFeed = async (slug) => {
    const response = await influencerService.getInstagramFeed(slug);
    if(response){
      const feed = (response.instagramStats && response.instagramStats.latestPosts) || [];
      this.props.loadInstagram(feed);
    }
  }

  getInfluencer = async (slug) => {
    const response = await influencerService.getInfluencer(slug);
    if (response.influencer) {
      const instagramUsername = response.influencer.instagram || null;
      if(instagramUsername){
        this.getInstagramFeed(slug);
      }
      this.props.loadProfile(response.influencer);
    } else {
      this.context.router.push('/not-found');
    }
  }

  render() {
    const { isLoading, isError, influencer, instagramFeed } = this.props;
    return (
      <div className="profile-page">
        <Header />
        {influencer && <Helmet
          defaultTitle="Dyzio influencer"
          titleTemplate="Dyzio influencer - %s"
          title={influencer && influencer.name}
        />}
        { !isError && isLoading && <LoadingView /> }
        { !isError && !isLoading &&
          <div className="profile">
            <section className="bg white">
              <div className="container">
                <Link to="/" className="back-link"><i className="fa fa-angle-left" /> Influencer search</Link>
                <Influencer details={influencer} />
              </div>
            </section>
            <section className="bg white border top">
              <div className="container">
                <SocialShare pinterestMedia={influencer.thumbnail} />
              </div>
            </section>
            <section className="bg gray">
              <div className="container">
                { influencer.latestYoutubeVideos && <YoutubeFeed videos={influencer.latestYoutubeVideos} /> }
              </div>
            </section>
            <section className="bg gray">
              <div className="container">
                {instagramFeed && <InstagramFeed feed={instagramFeed} />}
              </div>
            </section>
            <section className="bg gray last">
              <div className="container">
                { influencer.latestTweets && <LatestTweets tweets={influencer.latestTweets} /> }
              </div>
            </section>
          </div>
        }
      <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    instagramFeed: state.profile.get('instagramFeed'),
    influencer: state.profile.get('influencer'),
    isLoading: state.profile.get('isLoading'),
    isError: state.profile.get('isError'),
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    loadProfile: (influencer) => dispatch(Action.loadProfile(influencer)),
    loadInstagram: (instagramFeed) => dispatch(Action.loadInstagram(instagramFeed)),
    loadPage: () => dispatch(Action.loadPage()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);



// WEBPACK FOOTER //
// ./src/containers/profile/index.js